import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import * as actions from "../../store/actions";

import "./Cart.scss";

const Cart = ({
    cartTotal,
    cartTotalReady,
    itemForCart,
    setItemForCart,
    cartReadyForForm,
    history
}) => {
    const [isAmountChanged, setIsAmountChanged] = useState(false);

    useEffect(() => {
        cartTotalReady(itemForCart);
        return () => {
            setIsAmountChanged(false);
        };
    }, [itemForCart, isAmountChanged, cartTotalReady]);

    const handleAmount = (operator, item) => {
        if (operator === "+") {
            item.amount += 1;
        } else if (operator === "-" && item.amount > 1) {
            item.amount -= 1;
        }
        setIsAmountChanged(true);
    };

    const handleRemove = item => {
        let filteredCart = itemForCart.filter(itemInCart => {
            delete item.amount;
            return itemInCart.id !== item.id;
        });
        setItemForCart(filteredCart);
    };

    const renderCart = items => {
        if (!items) {
            return <div>LOADING...</div>;
        }
        if (items.length === 0) {
            return (
                <div className="cart__inner__emptyCart">
                    <p>
                        <b>Your cart is empty</b>
                    </p>
                </div>
            );
        } else {
            return itemForCart.map((item, i) => {
                if (item.amount === undefined) {
                    item.amount = 1;
                }
                return (
                    <div className="table" key={i}>
                        <div className="cart__inner__body">
                            <p className="cart__inner__body-product">{item.name}</p>

                            <p className="cart__inner__body-price">{item.price} czk</p>

                            <div className="cart__inner__body-amount">
                                <button onClick={() => handleAmount("-", item)}>-</button>
                                <input type="numeric" value={item.amount} />
                                <button onClick={() => handleAmount("+", item)}>+</button>
                            </div>

                            <div className="cart__inner__body-remove">
                                <button onClick={() => handleRemove(item)}>X</button>
                            </div>
                        </div>
                    </div>
                );
            });
        }
    };

    return (
        <div className="cart">
            <div className="container">
                <div className="heading" style={{ marginBottom: "10px" }}>
                    <h3>Your Order:</h3>
                </div>

                <div className="cart__inner">
                    <div className="cart__inner-items">{renderCart(itemForCart)}</div>
                    <div className="tf">
                        <div
                            className="row layout-inline"
                            style={{ backgroundColor: "#1f8330" }}
                        >
                            <div className="col">
                                <p
                                    className="font-beyond"
                                    style={{
                                        letterSpacing: "5px",
                                        textTransform: "capitalize"
                                    }}
                                >
                                    Total:
                                </p>
                            </div>
                            <div className="col">
                                <p>
                                    {cartTotal} {cartTotal === "" ? "" : "czk"}
                                </p>
                            </div>
                        </div>
                    </div>
                    <button
                        disabled={itemForCart.length === 0 ? true : false}
                        className="plr-20 color-white btn-fill-primary"
                        onClick={() => cartReadyForForm(itemForCart, history.push)}
                    >
                        Order
                    </button>
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = ({ menu }) => ({
    // cart: menu.cart,
    cartTotal: menu.cartTotal
});

const mapDispatchToProps = {
    cartReadyForForm: actions.cartReadyForForm,
    cartTotalReady: actions.cartTotalReady
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(Cart));
